import { BooleanDataDefinition } from "../../../rule-engine-core/Common/Data/Definitions/BooleanDataDefinition";
import { AndGroup } from "../../../rule-engine-core/Expressions/Expressions/Logic/AndGroup";
import { IsFalseExpression } from "../../../rule-engine-core/Expressions/Expressions/Logic/IsFalse";
import { IsTrueExpression } from "../../../rule-engine-core/Expressions/Expressions/Logic/IsTrue";
import { NotExpression } from "../../../rule-engine-core/Expressions/Expressions/Logic/NotExpression";
import { OrGroup } from "../../../rule-engine-core/Expressions/Expressions/Logic/OrGroup";
import { StringContainsExpression } from "../../../rule-engine-core/Expressions/Expressions/String/StringContainsExpression";
import { StringIsNotEmptyExpression } from "../../../rule-engine-core/Expressions/Expressions/String/StringIsNotEmptyExpression";
import { IntersectionRuleConfiguration } from "../../../rule-engine-core/Rule/Intersection/IntersectionRuleConfiguration";
import { getTestInputDataDefinition } from "../DataDefinition";

export const getIntersectionRuleEmpty = (): IntersectionRuleConfiguration => {
    const intersectionRule = new IntersectionRuleConfiguration();
    intersectionRule.inputData = getTestInputDataDefinition();

    return intersectionRule;
};

export const getIntersectionRulExample = (): IntersectionRuleConfiguration => {
    const intersectionRule = new IntersectionRuleConfiguration();
    intersectionRule.inputData = getTestInputDataDefinition();

    let isTrue = new IsTrueExpression();
    isTrue.value1.variableName = "exempt";
    intersectionRule.xaxisExpressions[0].expression = isTrue;

    intersectionRule.addXAxisExpression();

    let isFalse = new IsFalseExpression();
    isFalse.value1.variableName = "exempt";
    intersectionRule.xaxisExpressions[1].expression = isFalse;

    let orExp = new OrGroup();
    isTrue = new IsTrueExpression();
    isTrue.value1.variableName = "fullTime";

    orExp.elements[0].subExpression = isTrue;

    orExp.add();

    let textNotEmpty = new StringIsNotEmptyExpression();
    textNotEmpty.value1.variableName = "benefitsID";
    orExp.elements[1].subExpression = textNotEmpty;
    intersectionRule.yaxisExpressions[0].expression = orExp;

    intersectionRule.addYAxisExpression();

    let andExp = new AndGroup();

    isTrue = new IsTrueExpression();
    isTrue.value1.variableName = "fullTime";
    andExp.elements[0].subExpression = isTrue;

    andExp.add();

    isTrue = new IsTrueExpression();
    isTrue.value1.variableName = "isManager";
    andExp.elements[1].subExpression = isTrue;

    intersectionRule.yaxisExpressions[1].expression = andExp;

    intersectionRule.addYAxisExpression();

    andExp = new AndGroup();
    isFalse = new IsFalseExpression();
    isFalse.value1.variableName = "fullTime";
    andExp.elements[0].subExpression = isFalse;

    andExp.add();

    let containsExp = new StringContainsExpression();
    containsExp.value1.variableName = "benefitsID";
    containsExp.value2.value = "1AC";

    andExp.elements[1].subExpression = containsExp;

    intersectionRule.yaxisExpressions[2].expression = andExp;

    intersectionRule.addYAxisExpression();

    andExp = new AndGroup();
    isFalse = new IsFalseExpression();
    isFalse.value1.variableName = "fullTime";
    andExp.elements[0].subExpression = isFalse;

    andExp.add();

    containsExp = new StringContainsExpression();
    containsExp.value1.variableName = "benefitsID";
    containsExp.value2.value = "1AC";

    let notExp = new NotExpression();
    notExp.value1.subExpression = containsExp;

    andExp.elements[1].subExpression = notExp;

    intersectionRule.yaxisExpressions[3].expression = andExp;

    intersectionRule.results[0].setValue(false);
    intersectionRule.results[1].setValue(true);
    intersectionRule.results[2].setValue(true);
    intersectionRule.results[3].setValue(true);
    intersectionRule.results[4].setValue(false);
    intersectionRule.results[5].setValue(true);
    intersectionRule.results[6].setValue(false);
    intersectionRule.results[7].setValue(false);

    intersectionRule.setTypeResults(new BooleanDataDefinition());

    return intersectionRule;
};
